export default __webpack_public_path__ + "50118797fab69c267a14315768b32bbd.svg";